module.exports = __webpack_public_path__ + "static/img/kv01.0c9a214.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/layer5/nav-2/kv01.jpg
// module id = 1jn9
// module chunks = 0